<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSessionStore } from '@/stores/session'
import LoginView from '@/views/LoginView.vue'
import AppShell from '@/components/AppShell.vue'
import ClientBriefView from '@/views/ClientBriefView.vue'
import ClientDashboardView from '@/views/ClientDashboardView.vue'
import TeamWorkbenchView from '@/views/TeamWorkbenchView.vue'
import MembersView from '@/views/MembersView.vue'
import ModelConfigView from '@/views/ModelConfigView.vue'
import AgentSkillsView from '@/views/AgentSkillsView.vue'
import CollaborationView from '@/views/CollaborationView.vue'
import AdminWorkflowView from '@/views/AdminWorkflowView.vue'

const session = useSessionStore(); const { locale } = useI18n(); const view = ref('work')
const selectedBriefId = computed(() => view.value.startsWith('brief:') ? Number(view.value.slice(6)) : undefined)
onMounted(async () => { await session.restore(); locale.value = session.locale; view.value = session.user?.role === 'client' ? 'home' : 'work' })
watch(() => session.locale, value => { locale.value = value })
watch(() => session.user?.role, role => { if (role) view.value = role === 'client' ? 'home' : 'work' })
</script>

<template>
  <LoginView v-if="!session.authenticated" />
  <AppShell v-else :view="view" @change-view="view = $event">
    <ClientDashboardView v-if="session.user?.role === 'client' && view === 'home'" @open-brief="view = $event ? `brief:${$event}` : 'briefs'" />
    <ClientBriefView v-else-if="session.user?.role === 'client' && (view === 'briefs' || view.startsWith('brief:') || view === 'history')" :brief-id="selectedBriefId" :start-new="view === 'briefs'" :show-history="view === 'history'" @open-brief="view = `brief:${$event}`" @deleted="view = 'home'" />
    <TeamWorkbenchView v-else-if="view === 'work'" />
    <MembersView v-else-if="view === 'members'" />
    <ModelConfigView v-else-if="view === 'model'" />
    <AgentSkillsView v-else-if="view === 'skills'" />
    <CollaborationView v-else-if="view === 'collaboration'" />
    <AdminWorkflowView v-else-if="view === 'admin-workflow'" />
  </AppShell>
</template>
